import styled, { css } from 'styled-components'

import { FieldRow, Input } from '../../generic/Form'

export const SectionPanelColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 5px;
    border: none;
`

export const SectionEqualsSign = styled.div`
    font-weight: bold;
    display: flex;
    margin: 35px 10px;
    align-content: center;
    flex-wrap: wrap;
    padding: 4px;
`

export const ColorPickSquare = styled.div`
    margin-top: 5px;
    height: 30px;
    width: 30px;
    margin-left: auto;
    background-color: ${props => props.color};
`

export const AlarpIndicator = styled.div`
    height: 250px;
    width: 160px;
    background: linear-gradient(180deg, #55a97e 0%, #ffc83e 35.42%, #fe955f 69.27%, #e62b24 100%);
    transform: matrix(1, 0, 0, -1, 0, 0);
    clip-path: polygon(50% 0, 100% 100%, 0 100%);
`
export const AlarpThreshold = styled.div<{ top: string; triangleDirection?: string }>`
    width: 90%;
    height: 20px;
    border-bottom: 2px solid ${({ theme }) => theme['gray-1000']};
    position: absolute;
    top: ${props => props.top};
    left: 5%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    ${props =>
        props.triangleDirection === undefined
            ? css``
            : css`
                  &::before {
                      content: '';
                      border-top: 4px solid transparent;
                      border-left: 5px solid ${({ theme }) => theme['gray-1000']};
                      border-bottom: 4px solid transparent;
                      position: absolute;
                      top: 85%;
                  }
              `}

    &::after {
        content: '';
        width: 0px;
        height: 0px;
        position: absolute;
        ${props =>
            props.triangleDirection === undefined
                ? css`
                      border: none;
                  `
                : css`
                      border-top: 0px solid transparent;
                      border-bottom: 11px solid ${({ theme }) => theme['gray-1000']};
                      border-left: 18px solid transparent;
                      border-right: 18px solid transparent;
                  `}
        ${props =>
            props.triangleDirection === 'down'
                ? css`
                      bottom: -70%;
                      transform: rotate(180deg) !important;
                  `
                : css`
                      bottom: 0%;
                  `};
        right: 0%;
    }

    .form-group {
        input {
            height: 32px !important;
            border: 1px solid #dddee1;
            margin-top: 6px;
            background-color: ${({ theme }) => theme['gray-0']};
            padding: 0 8px;

            :read-only {
                background-color: ${({ theme }) => theme['gray-100']};
            }
        }
        &.has-error {
            input {
                border-color: var(--red-500);
            }
        }
    }
`

export const AlarpFieldRow = styled(FieldRow)`
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 40px;
    margin-bottom: 40px;
    border: none;
`

export const SettingsInput = styled(Input)`
    height: 32px !important;
    border: 1px solid #dddee1;
    margin-top: 6px;
    background-color: #eeeeee;
    /* border: none;
    outline: none;
    box-shadow: none; */
`

export const DeleteStatusThresholdButton = styled.div`
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    margin-top: 5px;
`

export const NewRuleBlock = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin-bottom: 20px;
`

export const NewRuleLine = styled.div`
    border-bottom: 1px solid #c8ccd4;
    margin-bottom: 16px;
    margin-left: 10px;
    margin-right: 10px;
    width: 40%;
`

export const DeleteStatusThresholdIcon = styled.i<{ showTrashIcon: boolean }>`
    position: relative;
    left: 20px;
    text-align: center;
    ${props =>
        props.showTrashIcon == true
            ? css`
                  color: red;
                  cursor: pointer;
              `
            : css`
                  pointer-events: none;
                  color: rgba(0, 0, 0, 0);
              `}
`
